// extracted by mini-css-extract-plugin
export default {"logoWrapper":"InvoiceBrandLogo_logoWrapper__eOHsS"};